import DefaultLayout from "@/components/layouts/DefaultLayout";
import ForgotPassword from "@/components/organisms/Forms/ForgotPassword";
import { SEO_DEFAULT } from "@/constants/SeoDefault";

const ForgotPasswordView = () => {
  return (
    <DefaultLayout seo={SEO_DEFAULT}>
      <div className="flex min-h-full items-center justify-center px-4 py-12 sm:px-6 lg:px-8">
        <div className="w-full max-w-md space-y-8">
          <div>
            <h1 className="mt-6 text-center text-3xl font-bold tracking-tight text-gray-900">
              Restablecer Contraseña
            </h1>
          </div>
          <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
            <div className="bg-white px-4 py-8 shadow sm:rounded-lg sm:px-10">
              <p className="mb-4 text-gray-700">
                Te enviaremos un email con las instrucciones para restablecer tu
                contraseña
              </p>
              <ForgotPassword />
            </div>
          </div>
        </div>
      </div>
    </DefaultLayout>
  );
};

export default ForgotPasswordView;
